import { render, staticRenderFns } from "./UIRowIndexLoader.vue?vue&type=template&id=70561bfe&scoped=true&"
import script from "./UIRowIndexLoader.vue?vue&type=script&lang=js&"
export * from "./UIRowIndexLoader.vue?vue&type=script&lang=js&"
import style0 from "./UIRowIndexLoader.vue?vue&type=style&index=0&id=70561bfe&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-2fffd51942/0/cache/vue-loader-npm-15.9.3-4ca89c7e4b-bc7d4c63e0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70561bfe",
  null
  
)

export default component.exports